import { IGmailLabel } from '@repo-sapiens/constants';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

const InboxSettingsSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },
  labels: { type: [mongoose.Schema.Types.Mixed] },
  created: { type: Date, default: Date.now() },
});

export type T_InboxSettingsBase = InferSchemaType<typeof InboxSettingsSchema>;

// Extend the type to provide proper typing for labels
export interface T_InboxSettings extends Omit<T_InboxSettingsBase, 'labels'> {
  labels?: (IGmailLabel & {
    id: string;
    backupName: string;
  })[];
}

export type T_InboxSettingsDocument = T_InboxSettings &
  Document & {
    _id: string;
  };

export { InboxSettingsSchema };
